'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
const processInclude = require('base/util');

processInclude(require('./common/common'));
processInclude(require('./login'));

$(() => {
    processInclude(require('./common/event-delegation'));
    processInclude(require('base/components/spinner'));
    processInclude(require('./components'));
    processInclude(require('./experience'));
    processInclude(require('./helpers'));
    processInclude(require('./adserver'));
    processInclude(require('./product/quickView'));
    processInclude(require('./pages'));
    processInclude(require('./contentModal'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./account'));
    processInclude(require('./order'));
    processInclude(require('./orderHistory'));
    processInclude(require('./clerkSession'));
    processInclude(require('./inputBirthdayMask'));
    processInclude(require('./inputSanitizer'));
    processInclude(require('./spsDatalayer'));
    processInclude(require('./tracking/serversideClickTracking'));
    processInclude(require('./consentTrackingSFRA/consentTrackingSFRA'));
    processInclude(require('./consentGoogleMaps/consentGoogleMaps'));
    processInclude(require('./webBridge'));
    processInclude(require('./tracking/tabBrowsing'));
    processInclude(require('./tracking/alertTracking'));
    processInclude(require('./newsletter/leadCreation'));
});

require('bootstrap/js/src/collapse.js');
require('bootstrap/js/src/dropdown.js');
require('bootstrap/js/src/modal.js');
require('bootstrap/js/src/tab.js');
require('bootstrap/js/src/tooltip.js');
require('bootstrap-select/js/bootstrap-select');
require('slick-carousel/slick/slick');
require('bootstrap/js/src/alert.js');